const columnPosition = [
  {
    title: "Index",
    scopedSlots: { customRender: "stt" },
    width: 50,
    align: "center",
  },
  {
    title: "Title",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
    sorter: (positionA, positionB) => {
      var codeA = positionA.name.toUpperCase();
      var codeB = positionB.name.toUpperCase();
      return codeA.localeCompare(codeB);
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
    width: 100,
    align: "center",
  },
  {
    title: "Create At",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 160,
  },
  {
    title: "Updated At",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 160,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 15,
  },
];

export { columnPosition };
